import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of, retry, throwError, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SIMULATE_HEALTH_ERROR } from 'src/app/app.constants';

@Injectable({ providedIn: 'root' })
export class HealthService {
  private http = inject(HttpClient);

  /*
  * Pings the public health endpoint to determine whether the backend is
  * actually reachable. Used purely as a diagnostic when an API call fails:
  * true  -> backends are healthy, so the failure is likely client-side
  *          (user network / iframe cross-origin blocking).
  * false -> health endpoint is unreachable or not ok (likely a full outage).
  * */
  check(): Observable<boolean> {
    const request$ = (environment.local && SIMULATE_HEALTH_ERROR)
      ? throwError(() => new Error('Simulated health check error'))
      : this.http.get<{ success?: boolean }>(environment.healthUrl);

    return request$.pipe(
      timeout(8000),
      retry({ count: 2, delay: 1000 }),
      map(r => r?.success === true),
      catchError(() => of(false))
    );
  }
}
